import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Phuongtientable from "components/Tracuuthongtin/Phuongtientable.js";
import Laixetable from "components/Tracuuthongtin/Laixetable.js";
import { Tooltip } from "@material-ui/core";
import dayjs from "dayjs";
import Config from "conFig.js";
const BlueOnGreenTooltip = withStyles({
  tooltip: { backgroundColor: "#c2c800" },
})(Tooltip);
export default function Thongtindoanhnghiepct() {
  const classes = useStyles();
  const [doanhnghiep, setDoanhnghiep] = React.useState([]);
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [sophuongtien, setSophuongtien] = React.useState(null);
  const [laixe, setLaixe] = React.useState([]);
  const [solaixe, setSolaixe] = React.useState(null);
  const [openpt, setOpenpt] = React.useState(false);
  const handleClosept = () => {
    setOpenpt(false);
  };
  const [openlx, setOpenlx] = React.useState(false);
  const handleCloselx = () => {
    setOpenlx(false);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdonvitheouser = () => {
    var url =
      Config.backend +
      "/api/Donvi/getdonviquanlytheouser?dmloaidonvi_id=1&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) {
          getphuongtientheodonvi(data[0].id);
          getlaixetheodonvi(data[0].id);
          getthongtindonvitheouser();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getthongtindonvitheouser = () => {
    console.log("ok");
    var url =
      Config.backend + "/api/Donvi/getdvvttheouser?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          if (data[0]) setDoanhnghiep(data[0]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getphuongtientheodonvi = (donvi_id) => {
    if (donvi_id > 0) {
      var url =
        Config.backend +
        "/api/Donvi/getphuongtientheodonvi?donvi_id=" +
        donvi_id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setPhuongtien(data);
          setSophuongtien(data.length);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const getlaixetheodonvi = (donvi_id) => {
    if (donvi_id > 0) {
      var url =
        Config.backend +
        "/api/Donvi/getlaixedv?donvi_id=" +
        donvi_id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setLaixe(data);
          setSolaixe(data.length);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getdonvitheouser();
  }, []);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn} style={{ width: "30%" }}>
            Thông tin
          </th>
          <th className={classes.tablebc_th_dn}>Nội dung</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td_dn}>Tên đơn vị</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.tendonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Địa chỉ</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.diachidonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số điện thoại</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.sodienthoai}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Loại hình kinh doanh</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.loaihinh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số giấy phép KD</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.giayphepdkkd}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Cơ quan cấp GPKD</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.coquancap}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Ngày cấp GPKD</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep.ngaycapgpdkkd
              ? dayjs(doanhnghiep.ngaycapgpdkkd).format("DD/MM/YYYY")
              : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số giấy phép</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.sogiayphep}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Ngày cấp giấy phép ĐKVT</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep.ngaycapgpkdvt
              ? dayjs(doanhnghiep.ngaycapgpkdvt).format("DD/MM/YYYY")
              : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Ngày hết hạn GP ĐKKDVT</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep.ngayhethangpkdvt
              ? dayjs(doanhnghiep.ngayhethangpkdvt).format("DD/MM/YYYY")
              : null}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Người đại diện</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.nguoidaidien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Người điều hành</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep.nguoidieuhanh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số phương tiện</td>
          <BlueOnGreenTooltip
            title={<a className={classes.tooltip}>Xem chi tiết</a>}
            placement="top-start"
          >
            <td
              className={classes.tablebc_td_dn}
              onClick={() => setOpenpt(true)}
              style={{ cursor: "default" }}
            >
              {sophuongtien}
            </td>
          </BlueOnGreenTooltip>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số lái xe</td>
          <BlueOnGreenTooltip
            title={<a className={classes.tooltip}>Xem chi tiết</a>}
            placement="top-start"
          >
            <td
              className={classes.tablebc_td_dn}
              onClick={() => {
                if (solaixe > 0) setOpenlx(true);
              }}
              style={{ cursor: "default" }}
            >
              {solaixe}
            </td>
          </BlueOnGreenTooltip>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "497px" }}>
      <a
        style={{
          display: "block",
          textAlign: "center",
          color: "blue",
          fontWeight: "bold",
          fontSize: 18,
          marginTop: 10,
        }}
      >
        THÔNG TIN VỀ DOANH NGHIỆP
      </a>
      <table className={classes.tablebc} style={{ marginTop: 8 }}>
        {tHead}
        {tBody}
      </table>
      <Modal
        open={openpt}
        onClose={handleClosept}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={8}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={10}>
                      <FormControl style={{ width: "100%", marginTop: "10px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Thông tin phương tiện
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleClosept} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <Phuongtientable phuongtien={phuongtien} />
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      <Modal
        open={openlx}
        onClose={handleCloselx}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={8}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={10}>
                      <FormControl style={{ width: "100%", marginTop: "10px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Thông tin lái xe
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloselx} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <Laixetable laixe={laixe} />
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </div>
  );
}
